module.exports = __webpack_public_path__ + "img/list.862ff733.svg";